import * as React from "react";
import Component from "../../AbstractComponent";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";

export default class AgreementDetailsEditable extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}
	
  public render() {
		const agencyFee: AgencyFeeInterface = this.props.agencyFee;

		return (
			<React.Fragment>
				<div className="contract-details-readonly">
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
						<div style={{display: "flex", alignItems: "baseline"}}>
							<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
								{this.trans("section/agencyfee-title")} 
							</div>
							{
								!this.props.isDefault && agencyFee?.status &&
								<div className="title" style={{color: agencyFee?.getStatusColor()}}>
									{this.trans(agencyFee?.status)}
								</div>
							}
						</div>
						{
							!this.props.isDefault && agencyFee?.firstDate &&
							<div className="date">
								{this.formatter.formatDate(agencyFee?.firstDate)}
							</div>
						}
						{
							!this.props.isDefault && !agencyFee?.firstDate && agencyFee?.date &&
							<div className="date">
								{this.formatter.formatDate(agencyFee?.date)}
							</div>
						}
					</div>
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "10px"}}>
						<div>
							<div className="counterparty" style={{color: "#757575"}}>
								{agencyFee?.counterparty?.displayName}
							</div>
						</div>

						<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
							<div className="amount">{this.formatter.formatNumber(agencyFee?.finalAmount, agencyFee?.currency)}</div>
						</div>
					</div>
						<table>
							<tr>
								<td className="align-left first-column">
									{`${this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}:`}
								</td>
								<td className="align-left">
									{agencyFee?.assignmentServiceStatus && agencyFee?.assignmentServiceStatus !== 1 && this.trans(`assignment_service_status_type_${ AssignmentServiceStatusTypeContainer.pickLabelFromId(agencyFee?.assignmentServiceStatus)?.toLowerCase()}`)}
								</td>
							</tr>
						{
							agencyFee?.percentageFee !== 0 && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("agreement-card/percentagefee-label")}:`}
									</td>
									<td className="align-left">
										{`${this.formatter.simpleFormatNumber(agencyFee?.percentageFee, false)}%`}
									</td>
								</tr>
							)
						}

						{
							agencyFee?.lastDate && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("label/end-date")}:`}
									</td>
									<td className="align-left">
										{this.formatter.formatDate(agencyFee?.lastDate)}
									</td>
								</tr>
							)
						}
					</table>
				</div>
				{this.props.editableFields}
			</React.Fragment>
		);
  }
}
